import * as React from 'react';
import { getWindow } from '../../../window/Window';

const CloseLoginModal: React.FC = () => {
  closeModal();
  return null;
};

const closeModal = () => {
  if (getWindow().parent.closeModal) {
    getWindow().parent.closeModal();
  }
};

export { CloseLoginModal };
